
import Typography from '@mui/material/Typography';


export const TextDrugDexlansoprazole = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Prescription lansoprazole is used to treat the symptoms of gastroesophageal reflux disease (GERD), a condition in which backward flow of acid from the stomach 
causes heartburn and possible injury of the esophagus (the tube between the throat and stomach) in adults and children 1 year of age and older. 
Prescription lansoprazole is used to treat the damage from GERD in adults and children 1 year of age and older. 
Prescription lansoprazole is used to allow the esophagus to heal and prevent further damage to the esophagus in adults with GERD. 
Prescription lansoprazole is also used to treat ulcers (sores in the lining of the stomach or intestine), 
to prevent more ulcers from developing in adults whose ulcers have already healed, and to decrease the risk that adults 
who are taking nonsteroidal anti-inflammatory drugs (NSAIDs) will develop ulcers. Prescription lansoprazole is also used to treat conditions 
where the stomach produces too much acid, such as Zollinger-Ellison syndrome in adults. Prescription lansoprazole is also used in combination 
with other medications to treat and prevent stomach ulcers caused by a certain type of bacteria (H. pylori) in adults. Nonprescription (over-the-counter) 
lansoprazole is used to treat frequent heartburn (heartburn that occurs two or more days per week) in adults. Lansoprazole is in a class of medications 
called proton pump inhibitors. It works by decreasing the amount of acid made in the stomach.
<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a695020.html

</Typography>

</div>

)
}